import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useAsync from '../hooks/useAsync';
import AdminServices from '../services/AdminServices';
import AdminUpdate from './Update Model/UpdateAdmin';
import Permissions from './UserPermission';
import DeleteButton from './Button/DeleteButton';
import Modal from 'react-modal';
import * as XLSX from 'xlsx';
Modal.setAppElement('#root');

function AdminUser() {
  const { data, run } = useAsync(AdminServices.getAllAdmin);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userTypeFilter, setUserTypeFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const handleViewDetails = (admin) => {
    setSelectedUser(admin);
    setIsModalOpen(true);
  };

  const handleEditDetails = (admin) => {
    setSelectedEdit(admin);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (admin) => {
    setSelectedEdit(admin);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const usersPerPage = 20;
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const filteredAdmins = (data?.data || []).filter((admin) => {
    const fullName = admin?.name ? admin.name.toLowerCase() : '';
    const email = admin?.email ? admin.email.toLowerCase() : '';
    const mobileNo = admin?.mobileNo ? admin.mobileNo.toString() : '';
    const city = admin?.city ? admin.city.toLowerCase() : '';

    return (
      (fullName.includes(searchQuery.toLowerCase().trim()) ||
        email.includes(searchQuery.toLowerCase()) ||
        city.includes(searchQuery.toLowerCase()) ||
        mobileNo.includes(searchQuery)) &&
      (userTypeFilter === '' || admin?.role === userTypeFilter)
    );
  });

  const currentAdmins = filteredAdmins.slice(indexOfFirstUser, indexOfLastUser);

  const generateExcel = () => {
    const filteredData = filteredAdmins.map((admin) => ({
      userType: admin?.role,
      name: admin?.name,
      email: admin?.email,
      city: admin?.city || "N/A",
      mobileNo: admin?.mobileNo,
      date: formatDate(admin?.createdAt),
      status: admin?.status
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Admins');
    XLSX.writeFile(wb, 'admin_data.xlsx');
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };


  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

        <div className="my-auto">

          <h5 className="page-title fs-21 mb-1">
            Admin User List
          </h5>
          <nav>

            <ol className="breadcrumb mb-0">

              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                User List
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
          <Link className="list-banner-btn" to="/add-admin" style={{ backgroundColor: "#343640" }}>
            {/* <img src="img/plus.svg" alt="" /> */}
            + Add User
          </Link>
          <div className="pe-1 mb-xl-0">
            <button className="excel-btn" onClick={generateExcel}>
              <img src="img/excel.svg" alt="Download Excel" />
              Download
            </button>

          </div>



        </div>
      </div>


      <div className="container-box px-0 user-manager">

        <div className="Tablesearch_design">
          <div className="row">
            <div className='col-md-6'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <input
                  type="search"
                  placeholder="Search by Name, Mobile and Email id"
                  name="search"
                  value={searchQuery}
                  className='form-control'
                  onChange={handleSearchChange}
                />
                <button className="search-btn">Search</button>
              </div>
            </div>
          </div>

        </div>
         {/* <div className="container-box-top-header px-4">

         <div className="col-sm-3">
            <div className="input-field">
              <select className="form-control" value={userTypeFilter} onChange={handleUserTypeChange}>
                <option value="">User Type</option>
                <option value="Android">Android</option>
                <option value="iOS">iOS</option>
              </select>
            </div>
          </div> 
        </div>*/}
        <div className="container-box-inner table-reponsive-tabe">
          <table id="example" className="table table-striped" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>USER TYPE</th>
                <th>NAME</th>
                <th>MOBILE NO.</th>
                <th>CITY</th>
                <th>EMAIL</th>
                <th>DATE</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentAdmins.map((admin, index) => (
                <tr key={admin?.id || index}>
                  <td>{index + 1 + indexOfFirstUser}</td>
                  <td><span className="usertype">{admin?.role || "N/A"}</span></td>
                  <td>{admin?.name || "N/A"}</td>
                  <td>{admin?.mobileNo || "N/A"}</td>
                  <td>{admin?.city || "N/A"}</td>
                  <td>{admin?.email || "N/A"}</td>
                  <td>{admin?.createdAt ? formatDate(admin.createdAt) : "N/A"}</td>
                  <td>
                    <div className="action_toggle_outer">
                      <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li>
                              <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                <i className="fa fa-close" />
                              </button>
                            </li>
                            <li>
                              <button className="edit" onClick={() => handleEditDetails(admin)}>Edit</button>
                            </li>
                            <li>
                              <button className="reject" onClick={() => handleDelete(admin)}>Delete</button>
                            </li>
                            <li>
                              <button className="approve" style={{ backgroundColor: '#263238' }} onClick={() => handleViewDetails(admin)}>Permission</button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Admin Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <Permissions admin={selectedUser} closeModal={closeModal} />
      </Modal>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <AdminUpdate admin={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
      </Modal>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton data={selectedEdit} page="Admin" closeModal={closeDeleteModal} onSuccess={run} />
      </Modal>
    </div>
  );
}

export default AdminUser;
